// extracted by mini-css-extract-plugin
export {};
    if(module.hot) {
      // 1792997014923
      var cssReload = require("/home/runner/work/1/s/client/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  